var ScoutingDepartmentPlayerAgentsController = (function () {
    function ScoutingDepartmentPlayerAgentsController(PlayerService) {
        this.$playerService = PlayerService;
    }
    ScoutingDepartmentPlayerAgentsController.prototype.$onInit = function () {
        var _this = this;
        this.promise = this.$playerService.getContacts(this.player._id);
        this.promise.then(function (contacts) { return (_this.contacts = contacts); });
    };
    return ScoutingDepartmentPlayerAgentsController;
}());
angular.module('app.scouting').component('scoutingDepartmentPlayerAgents', {
    templateUrl: 'scouting/components/department-player-agents.html',
    controller: ScoutingDepartmentPlayerAgentsController,
    bindings: {
        player: '<',
    },
});
;